<script lang="ts">
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { URL_ROOT } from '@mimir/web/configConstants';

export default defineComponent({
  name: 'MimirIcon',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'var(--v-strong-base)',
    },
    file: {
      type: String,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    maskStyle(): any {
      return {
        '-webkit-mask': `url(${this.fullPath}) no-repeat center`,
        'mask': `url(${this.fullPath}) no-repeat center`,
        'background-color': this.color,
        'opacity': this.disabled ? 0.3 : 1,
      };
    },
    fullPath(): any {
      return `${URL_ROOT}assets/icons/${this.fileName}`;
    },
    fileName(): any {
      if (this.file)
        return this.file + '.svg';
      if (this.$slots.default && this.$slots.default.length && this.$slots.default[0].text)
        return this.$slots.default[0].text.trim() + '.svg';
    },
  },
});
</script>

<template>
  <div ref="icon" :class="['mimir-icon', small && 'small']" :style="maskStyle" />
</template>

<style lang="stylus">
  .mimir-icon
    width: 24px
    height: 24px
    &.small
      width: 20px
      height: 20px
</style>
